import lottoService from '@/service/lottoService'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { ReferenceAction } from '@/service/resultReferenceTypes'

export default async function dispatchLottoEvent(vm, event, param, arg, callback) {
  const page = vm
  const { id } = page.$route.query
  if (!id || page.actionPending) return
  page.actionPending = true
  try {
    let payload = { ...(arg || {}) }
    let confirmed = false
    const calculate = [ReferenceAction.Calculate, 'calculateResultHistrory'].includes(event)
    const dispatch = [ReferenceAction.Dispatch, 'dispatchResultHistrory'].includes(event)
    if (calculate || dispatch) {
      const decision = await page.$refs.resultReferences.confirm(calculate ? ReferenceAction.Calculate : ReferenceAction.Dispatch, payload)
      if (decision.handled) {
        if (!decision.confirmation) return
        payload = calculate ? { ...payload, referenceConfirmation: decision.confirmation } : decision.confirmation
        confirmed = true
      }
    }
    if (!confirmed) {
      const decision = await page.$swal({
        dark: true,
        title: page.$t('Are you sure?'),
        text: page.$t('คุณเเน่ใจว่าต้องการดำเนินการใช่หรือไม่'),
        icon: 'info',
        showCancelButton: true,
        confirmButtonText: page.$t('Ok'),
        customClass: { confirmButton: 'btn btn-primary', cancelButton: 'btn btn-outline-danger ml-1' },
        buttonsStyling: false,
      })
      if (!decision.isConfirmed) return
    }
    const response = await lottoService.putAuthen(`huay/${event}/id/${id}${param || ''}`, payload)
    if (response.status !== 200) throw new Error(typeof response.data === 'string' ? response.data : page.$t('ดำเนินการไม่สำเร็จ'))
    page.huayData.status = response.data.status
    if (callback) callback(response)
    page.$toast({
      component: ToastificationContent,
      position: 'top-right',
      props: {
        title: page.$t('สำเร็จ'), icon: 'CoffeeIcon', variant: 'success', text: page.$t('ดำเนินการสำเร็จ'),
      },
    })
  } catch (error) {
    await page.$swal({ icon: 'error', title: page.$t('ดำเนินการไม่สำเร็จ'), text: error.message })
  } finally {
    page.actionPending = false
  }
}
